import { useState, useEffect } from 'react';
import { Button } from '../common/Button';
import { Modal } from '../common/Modal';
import { usePWAInstall } from '../../hooks/usePWAInstall';

export const InstallPrompt = () => {
  const { canPrompt, promptInstall } = usePWAInstall();
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Show prompt after user engagement (smart timing)
    // Only show if installation is available and not recently dismissed
    if (canPrompt) {
      const delay = process.env.NODE_ENV === 'test' ? 0 : 30000; // No delay in tests
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [canPrompt]);

  const handleInstallClick = async () => {
    const { outcome } = await promptInstall();

    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else if (outcome === 'dismissed') {
      console.log('User dismissed the install prompt');
    }

    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwa-install-dismissed', Date.now().toString());
  };

  // Don't show anything if conditions aren't met
  if (!showPrompt || !canPrompt) {
    return null;
  }

  return (
    <Modal isOpen={showPrompt} onClose={handleDismiss} title="Install Tarot Card Reader">
      <div className="space-y-4">
        <p className="text-gray-300">
          Install our app for a better experience! Get quick access from your home screen and enjoy:
        </p>
        
        <ul className="list-disc list-inside space-y-2 text-gray-300">
          <li>Faster loading times</li>
          <li>Offline access to your readings</li>
          <li>Full-screen experience</li>
          <li>Push notifications for updates</li>
        </ul>

        <div className="flex gap-3 pt-4">
          <Button
            variant="primary"
            onClick={handleInstallClick}
            className="flex-1"
          >
            Install App
          </Button>
          <Button
            variant="secondary"
            onClick={handleDismiss}
            className="flex-1"
          >
            Maybe Later
          </Button>
        </div>
      </div>
    </Modal>
  );
};
